import React from 'react'
import OvulationBanner from "../components/img/OvulationBanner.png";
const OvulationInductionBanner = () => {
  return (
    <div>
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={OvulationBanner} className="d-block w-100 carousel-image" alt="..." />
        </div>
      </div>
    </div>
  </div>
  )
}

export default OvulationInductionBanner
